import React from 'react';

import SelectSingleFilter from './SelectSingleFilter/SelectSingleFilter';
import SelectMultipleFilter from './SelectMultipleFilter/SelectMultipleFilter';
import BookingDateRangeFilter from './BookingDateRangeFilter/BookingDateRangeFilter';
import KeywordFilter from './KeywordFilter/KeywordFilter';
import PriceFilter from './PriceFilter/PriceFilter';

/**
 * FilterComponent is used to map configured filter types
 * to actual filter components
 */
const FilterComponent = props => {
  const {
    idPrefix,
    filterConfig,
    urlQueryParams,
    initialValues,
    getHandleChangedValueFn,
    validQueryParams,
    history,
    isManagePageFilter,
    handleFilterSubmit,
    customisedFilterOptions,
    onOpenFilterModal,
    onManageDisableScrolling,
    isManagePage,
    params,
    isProfile,
    isMobileModalOpen,
    isDesktop,
    isMoreFilterOpen,
    ...rest
  } = props;
  const { id, type, queryParamNames, label, config } = filterConfig;
  const { liveEdit, showAsPopup } = rest;

  const useHistoryPush = liveEdit || showAsPopup;
  const prefix = idPrefix || 'SearchPage';
  const componentId = `${prefix}.${id.toLowerCase()}`;
  const name = id.replace(/\s+/g, '-').toLowerCase();

  switch (type) {
    case 'SelectSingleFilter': {
      return (
        <SelectSingleFilter
          id={componentId}
          history={history}
          label={label}
          validQueryParams={validQueryParams}
          queryParamNames={queryParamNames}
          urlQueryParams={urlQueryParams}
          initialValues={initialValues(queryParamNames, liveEdit)}
          onSelect={getHandleChangedValueFn(useHistoryPush)}
          {...config}
          {...rest}
        />
      );
    }
    case 'SelectMultipleFilter': {
      return (
        <SelectMultipleFilter
          id={componentId}
          isManagePage={isManagePage}
          isMoreFilterOpen={isMoreFilterOpen}
          isDesktop={isDesktop}
          label={label}
          params={params}
          isProfile={isProfile}
          name={name}
          validQueryParams={validQueryParams}
          history={history}
          onOpenFilterModal={onOpenFilterModal}
          onManageDisableScrolling={onManageDisableScrolling}
          queryParamNames={queryParamNames}
          customisedFilterOptions={customisedFilterOptions}
          initialValues={initialValues(queryParamNames, liveEdit)}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          handleFilterSubmit={handleFilterSubmit}
          isManagePageFilter={isManagePageFilter}
          {...config}
          {...rest}
        />
      );
    }
    case 'BookingDateRangeFilter': {
      return (
        <BookingDateRangeFilter
          id={componentId}
          label={label}
          onOpenFilterModal={onOpenFilterModal}
          onManageDisableScrolling={onManageDisableScrolling}
          queryParamNames={queryParamNames}
          initialValues={initialValues(queryParamNames, liveEdit)}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          {...config}
          {...rest}
        />
      );
    }
    case 'PriceFilter': {
      return (
        <PriceFilter
          id={componentId}
          label={label}
          queryParamNames={queryParamNames}
          isDesktop={isDesktop}
          onOpenFilterModal={onOpenFilterModal}
          onManageDisableScrolling={onManageDisableScrolling}
          initialValues={initialValues(queryParamNames, liveEdit)}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          handleFilterSubmit={handleFilterSubmit}
          isManagePage={isManagePage}
          isProfile={isProfile}
          {...config}
          {...rest}
        />
      );
    }
    case 'KeywordFilter':
      return (
        <KeywordFilter
          id={componentId}
          label={label}
          name={name}
          onOpenFilterModal={onOpenFilterModal}
          onManageDisableScrolling={onManageDisableScrolling}
          queryParamNames={queryParamNames}
          initialValues={initialValues(queryParamNames, liveEdit)}
          onSubmit={getHandleChangedValueFn(useHistoryPush)}
          {...config}
          {...rest}
        />
      );
    default:
      return null;
  }
};

export default FilterComponent;
